<div class="start_button clrfx">
  <a
    routerLink="/add-offer"
    class="left small_radius bg_control_blue white_text ico_lamp"
  >
    {{ "Pages.OperationList.SendOffer1Text" | translate }}<br />
    {{ "Pages.OperationList.SendOffer2Text" | translate }}
  </a>
  <a routerLink="/" class="right small_radius bg_green white_text ico_task">
    {{ "Pages.OperationList.MyOffers1Text" | translate }}<br />
    {{ "Pages.OperationList.MyOffers2Text" | translate }}
  </a>
</div>

<div class="my_balance small_radius static_shadow bg_dark_blue clrfx">
  <div class="left">
    <div class="ttl">
      {{ "Pages.OperationList.MyBalanceText" | translate }}:
    </div>
    <div class="count_balance">
      <div class="ico">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.10202 18.898C1.80002 19.597 2.79802 19.966 3.98902 19.966C5.73102 19.966 7.84402 19.188 10.001 17.839C12.157 19.189 14.271 19.966 16.013 19.966C17.203 19.966 18.201 19.597 18.9 18.898C20.169 17.629 20.311 15.485 19.301 12.859C18.943 11.927 18.447 10.964 17.844 10C18.4198 9.09569 18.9077 8.13832 19.301 7.141C20.311 4.515 20.168 2.37 18.9 1.102C18.202 0.402997 17.204 0.0339966 16.013 0.0339966C14.271 0.0339966 12.158 0.811996 10.001 2.161C7.84502 0.810996 5.73102 0.0339966 3.98902 0.0339966C2.79902 0.0339966 1.80102 0.402997 1.10202 1.102C-0.166983 2.371 -0.309982 4.515 0.700018 7.141C1.05902 8.073 1.55402 9.036 2.15702 10C1.5812 10.9043 1.09331 11.8617 0.700018 12.859C-0.309982 15.485 -0.166983 17.629 1.10202 18.898ZM17.433 13.577C18.122 15.367 18.141 16.828 17.485 17.484C17.165 17.804 16.67 17.966 16.012 17.966C14.845 17.966 13.366 17.463 11.804 16.586C13.5954 15.2013 15.2027 13.5936 16.587 11.802C16.923 12.403 17.21 12.998 17.433 13.577ZM10 15.417C8.95604 14.6706 7.97478 13.8402 7.06602 12.934C6.15536 12.0246 5.31933 11.0434 4.56602 10C6.07164 7.91162 7.90694 6.08207 10 4.583C11.044 5.3294 12.0253 6.15983 12.934 7.066C13.8447 7.97538 14.6807 8.95654 15.434 10C13.9284 12.0884 12.0931 13.9179 10 15.417ZM16.012 2.034C16.669 2.034 17.164 2.196 17.485 2.516C18.141 3.172 18.123 4.633 17.433 6.423C17.21 7.002 16.923 7.597 16.587 8.198C15.204 6.40516 13.5966 4.79735 11.804 3.414C13.366 2.538 14.845 2.034 16.012 2.034ZM2.56702 6.423C1.87802 4.633 1.85902 3.172 2.51502 2.516C2.83502 2.196 3.33002 2.034 3.98802 2.034C5.15502 2.034 6.63402 2.537 8.19602 3.414C6.40347 4.79735 4.79599 6.40516 3.41302 8.198C3.08957 7.62699 2.80687 7.03385 2.56702 6.423ZM2.56702 13.577C2.79002 12.998 3.07702 12.403 3.41302 11.802C4.79599 13.5948 6.40347 15.2026 8.19602 16.586C6.63302 17.463 5.15502 17.966 3.98802 17.966C3.33102 17.966 2.83602 17.804 2.51502 17.484C1.85902 16.828 1.87802 15.367 2.56702 13.577Z"
            fill="white"
          />
          <path
            d="M10 12.574C11.4216 12.574 12.574 11.4216 12.574 10C12.574 8.57841 11.4216 7.42599 10 7.42599C8.57844 7.42599 7.42603 8.57841 7.42603 10C7.42603 11.4216 8.57844 12.574 10 12.574Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="count">{{ activityCount }}</div>
    </div>
  </div>
</div>

<div class="tab_view" id="history">
  <div class="page_name">
    {{ "Pages.OperationList.OperationListText" | translate }}
  </div>
  <div class="list_balance">
    <div
      class="item big_radius static_shadow"
      *ngFor="let operation of operations"
    >
      <div class="top_bar clrfx">
        <div class="left">
          <div
            class="status_inf small_radius bg_green"
            *ngIf="operation.chipsCount >= 0"
          >
            {{ "Pages.OperationList.ArrivedText" | translate }}
          </div>
          <div
            class="status_inf small_radius bg_red"
            *ngIf="operation.chipsCount < 0"
          >
            {{ "Pages.OperationList.SendedText" | translate }}
          </div>
          <div class="count green" *ngIf="operation.chipsCount >= 0">
            +{{ operation.chipsCount }}
          </div>
          <div class="count red" *ngIf="operation.chipsCount < 0">
            {{ operation.chipsCount }}
          </div>
        </div>
        <div class="right">{{ operation.date | date: "dd.MM.yyyy HH:ss" }}</div>
      </div>
      <div class="name">
        {{
          operation.activityId != 15
            ? operation.comment
            : operation.userFromId == userId
            ? ("Pages.OperationList.TransferSent" | translate) +
              " " +
              operation.userToName
            : ("Pages.OperationList.TransferReceived" | translate) +
              " " +
              operation.userFromName
        }}
      </div>
      <div class="bar">
        <b *ngIf="operation.offerNumber"> №{{ operation.offerNumber }} </b>
        {{ operation.offerName }}
      </div>
    </div>
  </div>
  <div class="button_block clrfx" *ngIf="showMoreBtn">
    <a class="button small_radius w100 border_blue" (click)="showMore()">
      {{ "Pages.OperationList.ShowMoreText" | translate }}
    </a>
  </div>
</div>
